<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="mr-2">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3>Finish AND UC Code</h3>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-form ref="form" v-model="valid">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-text-field
                            v-model="item.name"
                            prepend-icon="mdi-label"
                            label="Name*"
                            :rules="[rules.required]"
                            required
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-text-field
                            v-model="item.consecutive"
                            prepend-icon="mdi-numeric"
                            label="Consecutive*"
                            :rules="[rules.required]"
                            required
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-text-field
                            v-model="item.supplier"
                            hide-details
                            prepend-icon="mdi-truck-delivery"
                            label="Supplier"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-text-field
                            v-model="item.aama"
                            hide-details
                            prepend-icon="mdi-shield-check"
                            label="AAMA"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-text-field
                            v-model="item.covering"
                            hide-details
                            prepend-icon="mdi-spray"
                            label="Covering"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-textarea
                            v-model="item.description"
                            prepend-icon="mdi-text"
                            label="Description"
                            hide-details
                        >
                        </v-textarea>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex align-center mt-2 ml-1">
                    <v-switch
                        v-model="item.enabled"
                        color="primary"
                        label="Enabled"
                        hide-details
                        class="mt-0"
                    />
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                color="primary"
                class="mb-4"
                @click="saveProcess"
                rounded
                :loading="loading"
                :disabled="!valid"
            >
                SAVE
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import { objDiff } from '@/helpers/objDiff.js'

export default {
    name: 'ProcessForm',
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        originalItem: {
            type: Object,
            default: () => ({}),
        },
        createForm: {
            type: Boolean,
            default: () => false,
        },
        finishAndUCCodeSetting: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        loading: false,
        valid: false,
        rules: {
            required: v => !!v || 'This field is required',
        },
    }),
    computed: {
        itemDiff: function() {
            if (!this.createForm) {
                return objDiff(this.originalItem, this.item)
            } else {
                return null
            }
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async saveProcess() {
            if (this.createForm) {
                await this.create()
            } else {
                await this.update()
            }
        },
        async create() {
            try {
                this.loading = true
                const item = await API.createFinishAndUCCode({
                    settingId: this.finishAndUCCodeSetting.id,
                    ...this.item,
                })
                this.$emit('addItem', item)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async update() {
            try {
                this.loading = true
                const item = await API.updateFinishAndUCCode({
                    settingId: this.finishAndUCCodeSetting.id,
                    id: this.item.id,
                    ...this.itemDiff,
                })
                this.$emit('replaceItem', item)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        },
    },
    created() {
        if (this.item.enabled === undefined || this.item.enabled === null) {
            this.$set(this.item, 'enabled', true)
        }
    },
}
</script>

<style></style>
